import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  TournamentTeam, TournamentTeamFieldValue
} from '@mtgame/core';
import { TEAM_PHOTO_FIELD_ID, TEAM_UNIFORM_FIELD_ID } from '@utils/hardcode';

@Component({
  selector: 'mtg-tournament-team-uniform',
  templateUrl: './tournament-team-uniform.component.html',
  styleUrls: ['./tournament-team-uniform.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentTeamUniformComponent implements OnChanges {
  @Input()
  tournamentTeam: TournamentTeam;
  teamPhoto: TournamentTeamFieldValue;
  teamUniform: TournamentTeamFieldValue;

  ngOnChanges(changes: SimpleChanges) {
    if (this.tournamentTeam) {
      this.teamPhoto = this.tournamentTeam.fieldValues.find(item => item.leagueTeamField.id === TEAM_PHOTO_FIELD_ID);
      this.teamUniform = this.tournamentTeam.fieldValues.find(item => item.leagueTeamField.id === TEAM_UNIFORM_FIELD_ID);
    }
  }
}
